<template>
    <div class="footer">
      <div class="warp12">
        <div class="footer_l">
          <p>友情链接：</p>
          <a href="https://www.cast.org.cn/">中国科学技术协会</a>
          <a href="https://www.most.gov.cn/index.html">中华人民共和国科学技术部</a>
          <a href="https://www.cnipa.gov.cn/">中华人民共和国国家知识产权局</a>
        </div>
        <div class="footer_r">
          <p>© 1998-{{new Date().getFullYear()}} 中国知网（CNKI）</p>
          <p><span>京 ICP 证 040431 号</span><span>网络出版服务许可证 (总)网出证(京)字第 271 号</span><span>京公网安备 11010802020460 号</span></p>
          <p><span>《中国学术期刊（光盘版）》电子杂志社有限公司</span><span>KDN 平台基础技术由 KBASE 11.0 提供</span></p>
        </div>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

  <style>

  </style>
